import { Component, OnInit } from '@angular/core';
import {Title} from '@angular/platform-browser';

@Component({
  selector: 'app-solicitud-usuario',
  templateUrl: './solicitud-usuario.component.html',
  styleUrls: ['./solicitud-usuario.component.scss']
})
export class SolicitudUsuarioComponent implements OnInit {

  constructor(private titleService: Title) {
    this.titleService.setTitle('Solicitud de usuario');
  }

  ngOnInit(): void {
  }

}
